import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export enum EnumNotificationType {
  Info = 'info',
  Warning = 'warning',
  Success = 'success',
  Error = 'error',
}

export interface INotification {
  id: string | number;
  title: string;
  message: string;
  timestamp: Date;
  read: boolean;
  type?: EnumNotificationType;
}

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private subject = new BehaviorSubject<INotification[]>([]);

  // TODO: integrar notificacoes reais via API, socket.io ou Server-Sent Events
  // connectToSocket(): void { ... }
  // connectToSSE(): void { ... }

  notifications$ = this.subject.asObservable();

  markAsRead(id: string | number): void {
    this.subject.next(
      this.subject.value.map((n) => (n.id === id ? { ...n, read: true } : n))
    );
  }

  markAllAsRead(): void {
    this.subject.next(this.subject.value.map((n) => ({ ...n, read: true })));
  }
}
